import React, { useEffect } from 'react';
import { Downgraded, useState } from '@hookstate/core';
import { Box, Divider, CircularProgress } from '@mui/material';
import { useAuthState } from '../../stores/authStore';
import { useEventState } from '../../stores/eventStore';
import RouteConstants from '../../constants/routeConstants';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import { FULL_PERMISSION, VIEW_PERMISSION, REQUEST_STATUS_LIST } from '../../constants/Constant';
import { NO_ACCESS_PERMISSION } from '../../constants/Constant';
import { isEmpty } from 'lodash-es';
import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import UserList from './userList';
import AccordianCommonRequests from '../../sharedcomponents/commonRequest/accordianCommonRequest';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { generatePath, useHistory } from 'react-router-dom';
import AppConstants from '../../constants/appConstants';
import Title from '../../sharedcomponents/title/title';

const TransportSummary = () => {
    const eventState = useEventState();
    const authState = useAuthState();
    const loading = useState(false);
    const allTransportData = useState();
    const allHotelData = useState();
    const allListData = useState([]);
    const allDataFilterHotel = useState();
    const allDataFilterTransport = useState();

    const eventData = useState(null);
    const userID = useState(null);
    const filteredList = useState([]);
    const statusList = useState(REQUEST_STATUS_LIST);
    const [modPermission, setModPermission] = React.useState(null);
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const [showStatus, setShowStatus] = React.useState({
        Approved: 0,
        Pending: 0,
        Rejected: 0,
    });
    const history = useHistory();

    const [filters, setFilters] = React.useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [filterChangeVal, setFilterChangeVal] = React.useState(false);
    const [selectedUser, setSelectUser] = React.useState(0);
    const [participants, setParticipants] = React.useState([]);
    const userList = useState([]);
    const [participantList, setParticipantList] = React.useState(null);
    const eventParticipants = useState([]);
    // const [participants, setParticipants] = React.useState([]);

    // console.log(showStatus + filters + showSearchRec + filterChangeVal);
    // const [selectedUserName, setSelectedUserName] = React.useState('');
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [isCombine, setIsCombine] = React.useState(false);
    const [isDraft, setIsDraft] = React.useState(false);
    const [isAllStar, setIsAllStar] = React.useState(true);

    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');

    let eventRole = '';
    if (!isEmpty(eventInfo)) {
        eventRole =
            userInfo && userInfo.roles
                ? userInfo.roles.find(
                    (item) => item.eventID === eventInfo.eventID
                )?.eventRole
                : '';
    }
    useEffect(() => {
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            userID.set(userInfo.userID);
        }
        if (
            Helper.isAdminUser(userInfo) ||
            Helper.isEventAdmin(userInfo) ||
            Helper.isEventStaff(userInfo)
        ) {
            setModPermission(FULL_PERMISSION);
        } else {
            setModPermission(VIEW_PERMISSION);
        }
        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    useEffect(() => {

        let isCombine;
        let isDraft;
        let isAllStar;
        if (
            eventData.get() &&
            eventData.moduleDetails.get() &&
            eventData.moduleDetails.get().length > 0
        ) {
            isCombine = eventData.moduleDetails.get().some((module) =>
                module.moduleID === AppConstants.EVENT_MODULES.COMBINE_HOTEL
                || module.moduleID === AppConstants.EVENT_MODULES.COMBINE_TRANSPORTATION);
            isDraft = eventData.moduleDetails.get().some((module) =>
                module.moduleID === AppConstants.EVENT_MODULES.DRAFT_HOTEL
                || module.moduleID === AppConstants.EVENT_MODULES.DRAFT_TRANSPORTATION);
            isAllStar = eventData.moduleDetails.get().some((module) =>
                module.moduleID === AppConstants.EVENT_MODULES.ALL_STAR_HOTEL
                || module.moduleID === AppConstants.EVENT_MODULES.TRANSPORTATION);

            setIsCombine(isCombine);
            setIsDraft(isDraft);
            setIsAllStar(isAllStar);
        }


    }, [eventData])

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get()) {
            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo) || Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION);
            }
        }
    }, [eventState]);
    useEffect(() => {
        let list = [];
        if (
            allTransportData.attach(Downgraded).get() &&
            allTransportData.attach(Downgraded).get().length > 0
        ) {
            allTransportData
                .attach(Downgraded)
                .get()
                .map((key) => {
                    list.push({ name: key.participant, userID: key.userID });
                });
            let distinctUser = getUniqueBy(list, 'userID');
            userList.set(distinctUser);
        }
        if (
            allHotelData.attach(Downgraded).get() &&
            allHotelData.attach(Downgraded).get().length > 0
        ) {
            allHotelData
                .attach(Downgraded)
                .get()
                .map((key) => {
                    list.push({ name: key.participant, userID: key.userID });
                });

            let distinctUser = getUniqueBy(list, 'userID');
            userList.set(distinctUser);
        }
        if (
            userList.attach(Downgraded).get() &&
            userList.attach(Downgraded).get().length > 0
        ) {
            handleUserClick(userList.attach(Downgraded).get()[0].userID);
            return;
        }
    }, [
        allTransportData.attach(Downgraded).get(),
        allHotelData.attach(Downgraded).get(),
    ]);

    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage) {
                getAdminTransportSummary();

                getAdminHotelRequestList();
                getParticipantList();
            }
        }
    }, [modPermission]);

    const getAdminTransportSummary = () => {
        loading.set(true);
        let participantList = [];

        let combineTransportation;
        let draftTransportation;
        let allStarTransportation;
        if (
            eventInfo &&
            eventInfo.moduleDetails &&
            eventInfo.moduleDetails.length > 0
        ) {
            combineTransportation = eventInfo.moduleDetails.find(
                (module) => module.moduleName === 'CombineTransportation'
            );
            draftTransportation = eventInfo.moduleDetails.find(
                (module) => module.moduleName === 'DraftTransportation'
            );
            allStarTransportation = eventInfo.moduleDetails.find(
                (module) => module.moduleName === 'Transportation'
            );
        }
        // console.log("combineTransportation",combineTransportation,"draftTransportation",draftTransportation,"allStarTransportation",allStarTransportation);
        ApiHelper.get(
            combineTransportation ?
                APIURLConstants.GET_ADMIN_DRAFT_COMBINE_TRANSPORT_LIST(
                    eventData.get().eventID,
                    pagingInfo.get().currentPage,
                    pagingInfo.get().itemsPerPage
                )
                : draftTransportation ?
                    APIURLConstants.GET_ADMIN_DRAFT_TRANSPORT_LIST(
                        eventData.get().eventID,
                        pagingInfo.get().currentPage,
                        pagingInfo.get().itemsPerPage
                    ) :
                    APIURLConstants.GET_ADMIN_TRANSPORT_LIST(
                        eventData.get().eventID,
                        pagingInfo.get().currentPage,
                        pagingInfo.get().itemsPerPage
                    )
        )
            .then((res) => {
                if (res.data.rows) {
                    let data = res.data.rows;
                    let requestData = [];
                    if (data.length > 0) {
                        let approved = 0;
                        let pending = 0;
                        let rejected = 0;
                        data.map((item) => {
                            if (item.requestStatus === 'Approved') {
                                approved += 1;
                            } else if (item.requestStatus === 'Pending') {
                                pending += 1;
                            } else {
                                rejected += 1;
                            }
                            if (
                                participantList.indexOf(item.participant) == -1
                            ) {
                                participantList.push(item.participant);
                            }
                            requestData.push({
                                actualData: item,
                                userID: item.userID,
                                participant: item.participant,
                                row: [
                                    // {
                                    //     label: 'checkbox',
                                    //     key: 'transportID',
                                    //     transportID: item.transportID,
                                    //     width: '0.05',
                                    // },
                                    {
                                        label: 'Participant',
                                        key: 'participant',
                                        participant: item.participant,
                                        width: '0.25',
                                        showLabel: false,
                                        addLink: false,
                                        toEmail: item.email,
                                        showEmail: true,
                                        type: item.transportType,
                                        alignCenter: true,
                                        showEventType: true,
                                        eventType:
                                            item.transportType === 'air'
                                                ? `Event ${item.tripInfoType ===
                                                    'arrival'
                                                    ? 'Arrival'
                                                    : 'Departure'
                                                }`
                                                : '',
                                    },
                                    {
                                        label: 'Submitted By',
                                        key: 'submittedBy',
                                        submittedBy: item.submittedBy,
                                        width: '0.25',
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Date',
                                        key: 'date',
                                        date: Helper.FormatDate(item.date),
                                        width: '0.20',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Modified On',
                                        key: 'lastModifiedDate',
                                        lastModifiedDate: !Helper.IfDateIsNULL(
                                            item.lastModifiedDate
                                        )
                                            ? Helper.FormatDate(
                                                item.lastModifiedDate
                                            ) +
                                            ' ' +
                                            Helper.FormatTime(
                                                item.lastModifiedDate
                                            )
                                            : '',
                                        width: '0.25',
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    // {
                                    //     label: 'History',
                                    //     key: 'auditHistory',
                                    //     auditHistory: '',
                                    //     width: '0.05',
                                    //     showLabel: false,
                                    //     showChips: false,
                                    //     inColumn: true,
                                    //     // alignCenter: true,
                                    // },
                                    // {
                                    //     label: 'Shared',
                                    //     key: 'sharedWithVendor',
                                    //     sharedWithVendor: item.sharedWithVendor,
                                    //     width: '0.1',
                                    //     showSwitch: true,
                                    //     inColumn: true,
                                    //     alignCenter: true,
                                    // },
                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.10',
                                        showStatusIcon: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },

                                    // {
                                    //     label: 'Status',
                                    //     key: 'status',
                                    //     status: item.status
                                    //         ? 'Active'
                                    //         : 'Inactive',
                                    //     width: '0.1',
                                    // },
                                    {
                                        label: 'Action',
                                        key: 'All',
                                        all: 'All',
                                        width: '0.15',
                                    },
                                ],
                                selected: false,
                            });
                        });
                        setShowStatus({
                            Approved: approved,
                            Pending: pending,
                            Rejected: rejected,
                        });
                    } else {
                        setShowStatus({ Approved: 0, Pending: 0, Rejected: 0 });
                    }
                    setShowSearchRec(false);
                    let filterData = filteredList.attach(Downgraded).get();
                    if (filterData.length > 0) {
                        setFilterChangeVal(true);
                    }
                    allTransportData.set(requestData);
                    allListData.set(requestData);
                    setFilters({
                        transportType: ['Air', 'Ground'],
                        participant: participantList,
                        requestStatus: statusList.attach(Downgraded).get(),
                    });
                    loading.set(false);
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    const getAdminHotelRequestList = () => {
        let participantList = [];
        const userInfo = Helper.getStorage('userInfo');

        const eventInfo = Helper.getStorage('eventInfo');

        let combineHotel;
        let draftHotel;
        let allStarHotel;
        if (
            eventInfo &&
            eventInfo.moduleDetails &&
            eventInfo.moduleDetails.length > 0
        ) {
            combineHotel = eventInfo.moduleDetails.find(
                (module) => module.moduleName === 'Hotel'
            );
            draftHotel = eventInfo.moduleDetails.find(
                (module) => module.moduleName === 'DraftHotel'
            );
            allStarHotel = eventInfo.moduleDetails.find(
                (module) => module.moduleName === 'AllStarHotel'
            );
        }
        //console.log(combineHotel + ' ' + draftHotel + ' ' + allStarHotel);

        loading.set(true);

        ApiHelper.get(
            combineHotel
                ? APIURLConstants.GET_COMBINE_HOTELBOOKING_LIST(
                    eventData.get().eventID,
                    userInfo.userID,
                    userInfo.userType == 'Admin' || !isEmpty(eventRole)
                        ? true
                        : false,
                    false,
                    pagingInfo.get().currentPage,
                    pagingInfo.get().itemsPerPage
                )
                : draftHotel
                    ? APIURLConstants.GET_DRAFT_HOTELBOOKING_LIST(
                        eventData.get().eventID,
                        userInfo.userID,
                        userInfo.userType == 'Admin' || !isEmpty(eventRole)
                            ? true
                            : false,
                        false,
                        pagingInfo.get().currentPage,
                        pagingInfo.get().itemsPerPage
                    )
                    : APIURLConstants.GET_HOTELBOOKING_LIST(
                        eventData.get().eventID,
                        userInfo.userID,
                        userInfo.userType == 'Admin' || !isEmpty(eventRole)
                            ? true
                            : false,
                        false,
                        pagingInfo.get().currentPage,
                        pagingInfo.get().itemsPerPage
                    )
        )
            .then((res) => {
                if (res.data.rows) {
                    let data = res.data.rows;
                    let requestData = [];
                    if (data.length > 0) {
                        let approved = 0;
                        let pending = 0;
                        let rejected = 0;
                        data.map((item) => {
                            if (item.requestStatus === 'Approved') {
                                approved += 1;
                            } else if (item.requestStatus === 'Pending') {
                                pending += 1;
                            } else {
                                rejected += 1;
                            }
                            if (
                                participantList.indexOf(item.participant) == -1
                            ) {
                                participantList.push(item.participant);
                            }
                            requestData.push({
                                actualData: item,
                                userID: item.addedFor,
                                participant: item.participant,
                                row: [
                                    // {
                                    //     label: 'checkbox',
                                    //     key: 'hotelBookID',
                                    //     hotelBookID: item.hotelBookID,
                                    //     width: '0.05',
                                    //     inColumn: true,
                                    //     alignCenter: true,
                                    // },
                                    {
                                        label: 'Participant',
                                        key: 'participant',
                                        participant: item.participant,
                                        width: '0.20',
                                        showLabel: false,
                                        toEmail: item.email,
                                        showEmail: true,
                                    },
                                    {
                                        label: 'Room Type',
                                        key: 'hotelRoom',
                                        hotelRoom: item.hotelRoomTax,
                                        hotelRoomValue: item.hotelRoomTaxID,
                                        width: '0.20',
                                        inColumn: true,
                                        showHotelToggle: true,
                                        // asList: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Submitted By',
                                        key: 'createdBy',
                                        createdBy: item.createdByName,
                                        width: '0.20',
                                        inColumn: true,
                                    },
                                    // {
                                    //     label: 'Check In',
                                    //     key: 'checkIn',
                                    //     checkIn: Helper.FormatDate(item.checkIn),
                                    //     width: '0.15',
                                    // },
                                    // {
                                    //     label: 'Check Out',
                                    //     key: 'checkOut',
                                    //     checkOut: Helper.FormatDate(item.checkOut),
                                    //     width: '0.15',
                                    // },
                                    {
                                        label: 'Submitted Date',
                                        key: 'createdDate',
                                        createdDate: !Helper.IfDateIsNULL(
                                            item.createdDate
                                        )
                                            ? Helper.FormatDate(
                                                item.createdDate
                                            ) +
                                            ' ' +
                                            Helper.FormatTime(
                                                item.createdDate
                                            )
                                            : '',
                                        width: '0.25',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Modified On',
                                        key: 'modifiedDate',
                                        modifiedDate: !Helper.IfDateIsNULL(
                                            item.modifiedDate
                                        )
                                            ? Helper.FormatDate(
                                                item.modifiedDate
                                            ) +
                                            ' ' +
                                            Helper.FormatTime(
                                                item.modifiedDate
                                            )
                                            : '',
                                        width: '0.25',
                                        inColumn: true,
                                    },
                                    // {
                                    //     label: 'History',
                                    //     key: 'auditHistory',
                                    //     auditHistory: '',
                                    //     width: '0.05',
                                    //     showLabel: false,
                                    //     showChips: false,
                                    //     inColumn: true,
                                    // },
                                    // {
                                    //     label: 'Shared',
                                    //     key: 'shared',
                                    //     shared: item.shared,
                                    //     width: '0.15',
                                    //     showSwitch: true,
                                    //     inColumn: true,
                                    //     alignCenter: true,
                                    // },

                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.10',
                                        showStatusIcon: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },

                                    {
                                        label: 'Action',
                                        key: 'All',
                                        all: 'All',
                                        width: '0.15',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                ],
                                selected: false,
                            });
                        });
                        setShowStatus({
                            Approved: approved,
                            Pending: pending,
                            Rejected: rejected,
                        });
                    } else {
                        <StyledTableRow>
                            <StyledTableCell colSpan="7" align="center">
                                No data found
                            </StyledTableCell>
                        </StyledTableRow>;
                        setShowStatus({ Approved: 0, Pending: 0, Rejected: 0 });
                    }
                    setShowSearchRec(false);
                    let filterData = filteredList.attach(Downgraded).get();
                    if (filterData.length > 0) {
                        setFilterChangeVal(true);
                    }
                    allHotelData.set(requestData);
                    allListData.set(requestData);

                    setFilters({
                        participant: participantList,
                        requestStatus: statusList.attach(Downgraded).get(),
                    });
                    loading.set(false);

                    if (pagingInfo.get().noOfPages == null) {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                res.data.totalCount /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    const getParticipantList = () => {
        const gUserInfo = Helper.getStorage('userInfo');
        const gEventInfo = Helper.getStorage('eventInfo');
        if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) ||
            (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);
                    eventParticipants.set(participants);
                }
            });
        }
    };
    const handleUserClick = (id) => {
        // let data = [];
        allDataFilterHotel.set('');
        allDataFilterTransport.set('');
        setSelectUser(id);
        let transData =
            allTransportData.attach(Downgraded).get() &&
            allTransportData.attach(Downgraded).get().length > 0 &&
            allTransportData
                .attach(Downgraded)
                .get()
                .filter((x) => x.userID === id);
        let hotelData =
            allHotelData.attach(Downgraded).get() &&
            allHotelData.attach(Downgraded).get().length > 0 &&
            allHotelData
                .attach(Downgraded)
                .get()
                .filter((x) => x.userID === id);

        if (hotelData && hotelData.length > 0) {
            allDataFilterHotel.set(hotelData);
        }
        if (transData && transData.length > 0) {
            allDataFilterTransport.set(transData);
        }
    };
    const getUniqueBy = (arr, prop) => {
        const set = new Set();
        return arr.filter((o) => !set.has(o[prop]) && set.add(o[prop]));
    };

    const onListSelect = (event, item) => {
        let users = [...participants];
        let index = users.findIndex((x) => x.userID === item.userID);
        if (index > -1) {
            users[index].selected = event.target.checked;
            setParticipants(users);
            // props.handleAddToPdfListArray(event, item);
        }
    };

    const onListSelectAll = (event) => {
        // setSelectAllFlag(false);
        let users = [...participants];
        users.forEach((item, index) => {
            users[index].selected = event.target.checked;
        });
        setParticipants(users);
    };

    const redirectToEditRequest = (data) => {
        const row = data.actualData;
        if (row.hotelBookID) {
            const row = data.actualData;
            let registeredIds = allHotelData
                .attach(Downgraded)
                .get()
                .map((x) => x.actualData.addedFor);
            let index = registeredIds.indexOf(row.addedFor);
            registeredIds.splice(index, 1);
            // let filteredParticipants = participantList.filter(
            //     (x) => !registeredIds.includes(x.userID)
            // );
            let combineHotel;
            let draftHotel;
            let allStarHotel;
            if (
                eventInfo &&
                eventInfo.moduleDetails &&
                eventInfo.moduleDetails.length > 0
            ) {
                combineHotel = eventInfo.moduleDetails.find(
                    (module) => module.moduleName === 'Hotel'
                );
                draftHotel = eventInfo.moduleDetails.find(
                    (module) => module.moduleName === 'DraftHotel'
                );
                allStarHotel = eventInfo.moduleDetails.find(
                    (module) => module.moduleName === 'AllStarHotel'
                );
            }

            const path = generatePath(
                combineHotel
                    ? RouteConstants.EDIT_HOTEL_EVENT
                    : draftHotel
                        ? RouteConstants.EDIT_DRAFT_HOTEL_EVENT
                        : RouteConstants.EDIT_ALLSTAR_HOTEL_EVENT,
                {
                    eventID: eventData.get().eventID,
                    hotelBookingID: row.hotelBookID,
                }
            );

            history.push({
                pathname: path,
                state: {
                    hotelState: row,
                    participantList: participantList,
                    admin: true,
                },
            });
        } else {
            let combineTransport;
            let draftTransport;
            let allStarTransport;
            if (
                eventInfo &&
                eventInfo.moduleDetails &&
                eventInfo.moduleDetails.length > 0
            ) {
                combineTransport = eventInfo.moduleDetails.find(
                    (module) => module.moduleName === 'CombineTransportation'
                );
                draftTransport = eventInfo.moduleDetails.find(
                    (module) => module.moduleName === 'DraftTransportation'
                );
                allStarTransport = eventInfo.moduleDetails.find(
                    (module) => module.moduleName === 'Transportation'
                );
            }
            const path = generatePath(
                combineTransport
                    ? RouteConstants.DRAFT_COMBINE_EVENT_EDIT_TRANSIT
                    : draftTransport
                        ? RouteConstants.DRAFT_EVENT_EDIT_TRANSIT
                        : RouteConstants.EVENT_EDIT_TRANSIT,
                {
                    eventID: eventData.eventID.value,
                    transitID: combineTransport ? row.draftCombineTransportID : draftTransport ? row.draftTransportID : row.transportID,
                }
            );
            history.push({
                pathname: path,
                state: { transitType: row.transportType },
            });
        }
    };
    const onToggleChange = (item, index) => {
        item.expanded = !item.expanded;
        allDataFilterTransport[index].set(item);
    }
    // console.log("isCombine",isCombine, "isdraft", isDraft, "isAllStar",isAllStar);
    return (
        <Box sx={{
            width: '100%',
            overflow: 'auto'
        }}>
            <Box sx={{ padding: '0 8px', mx: 1.2, my: 2 }}>
                <Title title={'Transport Summary'}></Title>
            </Box>
            {loading.get() && loading.get() ? (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                        mx: 'auto',
                    }}>
                    <CircularProgress />
                </Box>
            ) : userList.attach(Downgraded).get() &&
                userList.attach(Downgraded).get().length === 0 ? (
                <Box sx={{ justifyContent: 'center' }}>
                    <Box>No data found</Box>
                </Box>
            ) : (
                <Box component="div" sx={{ display: 'flex' }}>
                    <Box
                        component="div"
                        sx={{
                            width: '20%',
                            padding: '0 8px',
                            display: 'flex',
                        }}>
                        <UserList
                            participants={userList.attach(Downgraded).get()}
                            handleUserClick={handleUserClick}
                            listSelect={onListSelect}
                            selectAll={onListSelectAll}
                            // allSelect={selectAllFlag ? true : false}
                            selected={selectedUser}
                        />
                    </Box>

                    <Box
                        component="div"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                        }}>
                        <AccordianCommonRequests
                            // new props
                            data={allDataFilterHotel.attach(Downgraded).get()}
                            editRow={redirectToEditRequest}
                            // handleClick={onAddRequest}
                            title={''}
                            // deleteRows={onDelete}
                            showSearch={false}
                            searchLabel={'Search'}
                            showFilter={false}
                            filters={filters}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            // onActionClick={onActionClick}
                            // showHistory={showHotelHistory}
                            // showExport={true}
                            // callExport={callExport}
                            // getResults={getAdminHotelRequestList}
                            pagingInfo={pagingInfo.attach(Downgraded).get()}
                            // handlePageChange={handlePageChange}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            // onPendingAction={onPendingAction}
                            modPermission={modPermission}
                            // filterListData={filterListData}
                            moduleToShow={'Hotel'}
                            moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.moduleDetails.get() : [],
                                isCombine ? AppConstants.EVENT_MODULES.COMBINE_HOTEL :
                                    isDraft ? AppConstants.EVENT_MODULES.DRAFT_HOTEL : AppConstants.EVENT_MODULES.ALL_STAR_HOTEL)}
                            filterChangeVal={filterChangeVal}
                            // showSelectedUser={selectedUserName}
                            // loading={loading.get()}
                            hideToolBar={true}
                            showMenuAdd={false}
                            hideAdd={true}
                            hideDelete={true}
                            hideSelectAll={true}
                            show={showStatus}
                            hideReject={true}
                            hideApprove={true}
                            showExpandCollapseValue={true}
                            setAutoHeight={true}
                            hideModuleInfo={true}
                        /> 
                        <Divider sx={{ m: 1 }} />                        
                        <AccordianCommonRequests
                            // new props
                            data={allDataFilterTransport
                                .attach(Downgraded)
                                .get()}
                            editRow={redirectToEditRequest}
                            // handleClick={onAddRequest}
                            title={''}
                            // deleteRows={onDelete}
                            showSearch={false}
                            searchLabel={'Search'}
                            showFilter={false}
                            filters={filters}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            // onActionClick={onActionClick}
                            // showHistory={showHotelHistory}
                            // showExport={true}
                            // callExport={callExport}
                            // getResults={getAdminHotelRequestList}
                            pagingInfo={pagingInfo.attach(Downgraded).get()}
                            // handlePageChange={handlePageChange}
                            snackBarProps={snackBarProps}
                            hideToolBar={true}
                            setSnackBarProps={setSnackBarProps}
                            // onPendingAction={onPendingAction}
                            modPermission={modPermission}
                            // filterListData={filterListData}
                            moduleToShow={isCombine ? "Combine Transportation" :
                                isDraft ? "Draft Transportation" : 'Flight Info'}
                            moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.moduleDetails.get() : [],
                                isCombine ? AppConstants.EVENT_MODULES.COMBINE_TRANSPORTATION :
                                    isDraft ? AppConstants.EVENT_MODULES.DRAFT_TRANSPORTATION : AppConstants.EVENT_MODULES.TRANSPORTATION)}
                            filterChangeVal={filterChangeVal}
                            // showSelectedUser={selectedUserName}
                            // loading={loading.get()}
                            showMenuAdd={false}
                            hideAdd={true}
                            hideDelete={true}
                            hideSelectAll={true}
                            hideReject={true}
                            hideApprove={true}
                            showExpandCollapseValue={true}
                            setAutoHeight={true}
                            windowAccordDataList={true}
                            rowType={isCombine ? "combinetransport" :
                                isDraft ? "draftTransport" : 'AllStarTransport'}
                            onToggleChange={onToggleChange}
                            showShared={false}
                            showHistory={false}
                            hideRowCheckbox={true}
                        />
                    </Box>
                </Box>
            )}

            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.TRANSPORT_SUMMARY,
        component: TransportSummary,
    },
    name: 'TransportSummary',
};
